export default __webpack_public_path__ + "static/media/img3.129ffe56.webp";